export default {
  id: null,
  empresaid: null,
  codigo: 0,
  tipo: 1,
  descricao: null,
  itemInicio: false,
  itemFim: false,
  dfd: false,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/copitemmodel.js